import React from 'react';
type OrnamentProps = {
  className?: string;
  align?: 'left' | 'center';
};

/** Small printer's mark, the kind a book sets between sections. */
export function Ornament({
  className = '',
  align = 'center'
}: OrnamentProps) {
  const stroke = 'rgba(138, 107, 61, 0.7)';
  return <div aria-hidden="true" className={`flex items-center gap-4 ${align === 'center' ? 'justify-center' : ''} ${className}`} data-id="element-45" data-mp="7269yf31scxz">
      {align === 'center' && <span className="h-px w-12 sm:w-20" style={{
      background: `linear-gradient(to right, transparent, ${stroke})`
    }} data-id="element-46" data-mp="2yhyhlbaox7g" />}
      <svg width="44" height="12" viewBox="0 0 44 12" fill="none" data-id="element-47" data-mp="3p8u8fm3le1uo">
        <path d="M22 1.5 C25 4 25 8 22 10.5 C19 8 19 4 22 1.5 Z" stroke={stroke} strokeWidth="0.7" data-id="element-48" data-mp="3k8y75uma4oit" />
        <path d="M15 6 H19" stroke={stroke} strokeWidth="0.7" data-id="element-49" data-mp="1ng62v63h72bq" />
        <path d="M25 6 H29" stroke={stroke} strokeWidth="0.7" data-id="element-50" data-mp="1nebt8nxnmwmy" />
        <circle cx="12" cy="6" r="0.8" fill={stroke} data-id="element-51" data-mp="1iiedoju7tub8" />
        <circle cx="32" cy="6" r="0.8" fill={stroke} data-id="element-52" data-mp="3py3igqi01f8g" />
      </svg>
      <span className="h-px w-12 sm:w-20" style={{
      background: `linear-gradient(to left, transparent, ${stroke})`
    }} data-id="element-53" data-mp="3pwirtbyt2gfv" />
    </div>;
}